import { useState } from "react";

import EmailForm from "./signIn/EmailForm";
import LoginCodeForm from "./signIn/LoginCodeForm";

const SignInForm = ({
  disabled,
  onSuccess,
}: {
  disabled?: boolean;
  onSuccess: () => void;
}) => {
  const [codeResponse, setCodeResponse] = useState<
    undefined | Record<string, string>
  >(undefined);

  if (codeResponse) {
    return (
      <LoginCodeForm
        codeResponse={codeResponse}
        disabled={disabled}
        onSuccess={onSuccess}
      />
    );
  }

  return <EmailForm disabled={disabled} onSuccess={setCodeResponse} />;
};

export default SignInForm;
